import 'ui-core/utility/js/utils';

(function () {
    var achsUtils = {
        listenersClickCallback: [],
        listenersEscCallback: [],
        listenersOptions: {capture: true},

        getParameterByName: function (name, url) {
            var regex, results;
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

            regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            results = regex.exec(url);

            return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },

        mutationObserverSubscription: function (
            customCallback = null,
            targetNode,
            config = {attributes: true},
            once = true
        ) {
            if (!targetNode) return;

            const callback = (mutationList, observer) => {
                if (customCallback) {
                    customCallback(mutationList, observer);
                }

                if (once) {
                    observer.disconnect();
                }
            };

            const observer = new MutationObserver(callback);

            observer.observe(targetNode, config);
        },

        createAlert: function (customAlertElement, alertMessage) {
            const alertElement = customAlertElement || document.querySelector('.ui-helper-hidden-accessible');

            if (!alertElement || !alertMessage) return;

            alertElement.textContent = alertMessage;

            setTimeout(() => {
                alertElement.textContent = '';
            }, 2000);
        },

        addCloseTooltipsListener: function (target, callback) {
            const callbackFunction = e => {
                UX.achsUtils.handleOutsideClicks(e, target, callback);
            };

            achsUtils.listenersClickCallback.push(callbackFunction);
            achsUtils.listenersEscCallback.push(callbackFunction);

            document.body.addEventListener('click', callbackFunction, achsUtils.listenersOptions);
            document.body.addEventListener('keydown', callbackFunction, achsUtils.listenersOptions);
        },

        removeCloseTooltipsListener: function () {
            achsUtils.listenersClickCallback.forEach((callback, i) => {
                document.body.removeEventListener('click', callback, achsUtils.listenersOptions);

                document.body.removeEventListener(
                    'keydown',
                    achsUtils.listenersEscCallback[i],
                    achsUtils.listenersOptions
                );
            });

            achsUtils.listenersClickCallback = [];
            achsUtils.listenersEscCallback = [];
        },

        handleOutsideClicks: function (e, target, callback) {
            const isInsideElement = target?.contains(e.target);
            const isEscKey = e.key === 'Escape';

            if (!isInsideElement || isEscKey) {
                callback();
                achsUtils.removeCloseTooltipsListener();
            }
        },

        animationEmulator: function (element, callback) {
            if (!element) return;

            const onAnimationEnd = () => {
                callback?.();
                element.removeEventListener('animationend', onAnimationEnd);
            };

            element.addEventListener('animationend', onAnimationEnd);
        },
    };
    UX.achsUtils = achsUtils;
})();
